import { Link, useNavigate } from "react-router-dom";
import { LogOut, ArrowLeft } from "lucide-react";
import { ThemeToggle } from "@/components/dashboard/ThemeToggle";
import { NotificationBell } from "@/components/dashboard/NotificationBell";
import { MeltoLogo } from "@/components/MeltoLogo";

export const PrivateHeader = ({ title, badge, theme, onToggleTheme }) => {
  const navigate = useNavigate();
  const logout = () => {
    localStorage.removeItem("melto_token");
    navigate("/login");
  };

  return (
    <header className="sticky top-0 z-40 border-b border-[var(--pv-border)] bg-[var(--pv-header)]  backdrop-blur-xl">
      <div className="mx-auto flex max-w-6xl items-center justify-between px-4 py-3 sm:px-6">
        <div className="flex items-center gap-3">
          <MeltoLogo size={36} testid="header-logo-mark" />
          <div>
            <p className="font-mono-label text-[10px] font-bold uppercase tracking-widest text-cyan-400">Melto Studios</p>
            <div className="flex items-center gap-2">
              <p className="font-display text-base font-semibold text-[var(--pv-text)]">{title}</p>
              {badge}
            </div>
          </div>
        </div>
        <div className="flex items-center gap-2">
          <NotificationBell />
          {theme && onToggleTheme && <ThemeToggle theme={theme} onToggle={onToggleTheme} />}
          <Link
            data-testid="private-view-site-link"
            to="/"
            className="hidden items-center gap-1.5 rounded-full bg-[var(--pv-raised)] px-3.5 py-2 text-xs font-semibold text-[var(--pv-text-4)] transition-colors hover:bg-[var(--pv-raised)] sm:flex"
          >
            <ArrowLeft className="h-3.5 w-3.5" /> View site
          </Link>
          <button
            data-testid="private-logout-btn"
            onClick={logout}
            className="flex items-center gap-1.5 rounded-full bg-[var(--pv-raised)] px-3.5 py-2 text-xs font-semibold text-[var(--pv-text)] transition-colors hover:bg-[var(--pv-raised)]"
          >
            <LogOut className="h-3.5 w-3.5" /> Logout
          </button>
        </div>
      </div>
    </header>
  );
};
